//hotel form
!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (window.define)
		define('hotels/guidedNav',['libs/ct_pubsub'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module()
}('guidedNav', function() {

	var guidedNav = {

		initialize : function() {

		},
		events : function() {

		}
	}

	CT.subscribe('guidedNavTrigger', function() {// fired from searchTab.js
		var availCount = 0, tmp;
		var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);

		_.each(CT.masterJson.get().ht,function(item,ind){
			if(item.priceInfo){
				availCount++;
			}
		})
		CT.cache[CT.settings.currentTab].availableCount = availCount;
		CT.avaiActiveHotel = availCount;
		CT.totalHotel = CT.masterJson.get().ht.length;
		if (CT.subProd != "wg" && CT.avaiActiveHotel > CT.settings.hotel.guidedNavThreshold && CT.cache[CT.settings.currentTab].isCitySearch === true && CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false) {
			//$("#ResultContainer_" + CT.settings.currentTab).find(".guidedMessage").show();
			//$("#ResultContainer_" + CT.settings.currentTab).find(".guidedNav").remove();
			$currentTab.find(".pinPointBlock .pinPointPriMess").html(CT.messages.hotel.Got + CT.totalHotel + CT.messages.hotel.HotelToChoose)
			tmp = $currentTab.find('.pinPoint');
			//tmp.css('left', (($(document).width() - tmp.width())/2) + 'px');
			$currentTab.find(".pinPointInit").fadeOut("slow",function(){
				$currentTab.find("#pinPointStaticBlock").fadeIn("slow");
			})
		}
	});

	CT.subscribe('guidedNavScrollTrigger', function() {// fired from searchTab.js
		var availCount = 0, tmp;
		var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);

		_.each(CT.masterJson.get().ht,function(item,ind){
			if(item.priceInfo){
				availCount++;
			}
		})
		CT.cache[CT.settings.currentTab].availableCount = availCount;
		CT.avaiActiveHotel = availCount;
		CT.totalHotel = CT.masterJson.get().ht.length;
		if (CT.subProd != "wg" && CT.avaiActiveHotel > CT.settings.hotel.guidedNavThreshold && CT.cache[CT.settings.currentTab].isCitySearch === true && CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false) {
			//$("#ResultContainer_" + CT.settings.currentTab).find(".guidedMessage").show();
			//$("#ResultContainer_" + CT.settings.currentTab).find(".guidedNav").remove();
			$currentTab.find(".pinPointBlock .pinPointPriMess").html(CT.messages.hotel.Got + CT.totalHotel + CT.messages.hotel.HotelToChoose)
			
			tmp = $currentTab.find('.pinPoint');
			tmp.css('left', (($(document).width() - tmp.width())/2 - 10) + 'px');
			$currentTab.find("#pinPointStaticBlock").fadeOut("slow",function(){
				$currentTab.find("#pinPointScrollBlock").show();
				$currentTab.find(".pinPointInit").show().addClass('animated bounceInDown');
			})
		}
	});
	
	
	CT.subscribe('guidedNavFilter', function() {
		var obj = CT.guidedNavFilterObj;
		var currTab = CT.settings.currentTab;
		var currentCont = $("#ResultContainer_" + currTab);
		var lowerVal = CT.cache[currTab].filterValues.priceMinMax.min;
		var higherVal = CT.cache[currTab].filterValues.priceMinMax.max;
		var perNight = parseInt(CT.cache[CT.settings.currentTab].searchParams.processed.num_nights);
		var perRoom = parseInt(CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms);
		var checkOthers = false,ele,tmp,fLeft;
		var tmp;
		CT.cache[CT.settings.currentTab].guidedNav = false;
		CT.cache[CT.settings.currentTab].GNFilterApplied = true;
		CT.cache[CT.settings.currentTab].filterApplied = [];
		if (obj.sr !== "") {
			for(var i=1;i<6;i++){
				if( i != parseInt(obj.sr) && checkOthers == false){
					ele = currentCont.find(".filterContent .starFilter").find("input#"+currTab + i);
					ele.removeAttr("checked");
				}else{
					ele = currentCont.find(".filterContent .starFilter").find("input#"+currTab + i);
					ele.attr("checked","checked");
					checkOthers = true;
				}
			}
			CT.cache[CT.settings.currentTab].filterApplied.push("starFilter");
			//ele = currentCont.find(".filterContent.starFilter").find("input#"+obj.sr+"_currTab.replace('_','')");
		}else{
			for(var i=1;i<6;i++){
				ele = currentCont.find(".filterContent .starFilter").find("input#"+currTab + i);
				ele.attr("checked","checked");	
			}
		}
		if(obj.pType !== "" && obj.pType.length>0){
			var pTypeEle;
			for(var i=0;i < currentCont.find(".filterContent .propertyType").find("input").length;i++){
				pTypeEle = currentCont.find(".filterContent .propertyType").find("input")[i];
				if(!_.contains(obj.pType, $(pTypeEle).val())){
					$(pTypeEle).removeAttr("checked");
				}
			}
		}else{
			for(var i=0;i < currentCont.find(".filterContent .propertyType").find("input").length;i++){
				pTypeEle = currentCont.find(".filterContent .propertyType").find("input")[i];
				$(pTypeEle).attr("checked","checked");	
			}
		}
		if(obj.amType && obj.amType.length>0){
			var eleType;
			for(var k in obj.amType){
				eleType = currentCont.find(".filterContent .amenity").find("input#"+currTab + obj.amType[k]);
				eleType.attr("checked","checked");
			}
		}else if(obj.removeAm && obj.removeAm == true){
			for(var k in currentCont.find(".filterContent .amenity").find("input:checked")){
				eleType = currentCont.find(".filterContent .amenity").find("input:checked")[k];
				$(eleType).removeAttr("checked");
			}
		}
		if (obj.ta !== "") {
			var taValue = Math.ceil(obj.ta)
			currentCont.find(".filterContent .taStarRating").slider("option",{trigger:false,"value":taValue}).slider("option",{trigger:true});
			currentCont.find('.filtersForm').find('input[name="taStarRating"]').val(taValue + '-5')
			if (obj.ta === 1) {
				fLeft = CT.messages.hotel.AnyRating;
			} else if (obj.ta === 5) {
				fLeft = CT.messages.hotel.Rating + "5";
			} else {
				fLeft = CT.messages.hotel.Rating + obj.ta + CT.messages.hotel.andAbove;
			}
			tmp = $('.taStarRating').closest('.block');
			tmp.find('.displayFilterValue .fLeft').html(fLeft);
			CT.cache[CT.settings.currentTab].filterApplied.push("displayFilterValue");
		}
		if (obj.locality && obj.locality !== "") {
			if(_.isArray(obj.locality)) {
				CT.utils.mw.addlocations(obj.locality, 'dontTriggerFilter');
			} else {
				CT.utils.searchAreaPoi.addToLocalities(undefined, obj.locality, 'dontTriggerFilter');
			}
			CT.cache[CT.settings.currentTab].filterApplied.push("locality");
		}
		if (obj.price !== "") {
			if (obj.price[0] === 0) {
				var lower = obj.price[0];
				var higher = obj.price[1];
				//var lower = lowerVal;
			//	var higher = lowerVal * 2 > (obj.price[1] * perNight * perRoom) ? lowerVal * 2 : (obj.price[1] * perNight * perRoom);
				//currentCont.find(".filterContent .price").priceslider({min : lower, max : higher, isReady : false})
				currentCont.find(".filterContent .price").slider("option", "values", [lower, higher , false]);
				currentCont.find('.filtersForm').find('input[name="price"]').val(lower + '-'+ higher)
			} else {
				var lower = obj.price[0];
				var higher = obj.price[1];
				
				//var lower = lowerVal * 2 > (obj.price[0] * perNight * perRoom) ? lowerVal * 2 : (obj.price[0] * perNight * perRoom);
				//var higher = lowerVal * 4 > (obj.price[1] * perNight * perRoom) ? lowerVal * 4 : (obj.price[1] * perNight * perRoom);
				//currentCont.find(".filterContent .price").priceslider({min : lower, max : higher, isReady : false})
				currentCont.find(".filterContent .price").slider("option", "values", [lower, higher , false]);
				currentCont.find('.filtersForm').find('input[name="price"]').val(lower + '-'+ higher)
			}
			CT.cache[CT.settings.currentTab].filterApplied.push("displayFilterValue");
		}else{
			var lower = CT.cache[currTab].filterValues.priceMinMax.min + 1;
			var higher = CT.cache[currTab].filterValues.priceMinMax.max;
			currentCont.find(".filterContent .price").slider("option", "values", [lower, higher , false]);
			//currentCont.find(".filterContent .price").priceslider({min : lower, max : higher, isReady : false})
			currentCont.find('.filtersForm').find('input[name="price"]').val(lower + '-'+ higher)
		}
		
		 CT.fire("filters.apply");
		 CT.cache[CT.settings.currentTab].GNFilterApplied = false;
		$("#ResultContainer_" + currTab).find(".guidedMessage").hide();
		window.scrollTo(0,0);
		
		
	});

	return guidedNav;

}, CT);

